import {Injectable} from "@angular/core";
import {DataSource} from "@angular/cdk/collections";
import {BehaviorSubject, Observable} from "rxjs";
import {UserService} from "../../../../@shared/services/user.service";
import {
  IBalanceHistoryBody,
  IBalanceHistoryResponse,
  IWalletTransaction
} from "../services/interfaces/balance-history.interface";


@Injectable()
export class BalanceHistoryDataSource extends DataSource<any> {

  balanceHistory$: BehaviorSubject<IWalletTransaction[]> = new BehaviorSubject<IWalletTransaction[]>([]);

  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  totalCount: number | undefined = 0;

  constructor(private userService: UserService) {
    super();
  }

  connect(): Observable<IWalletTransaction[]> {
    return this.balanceHistory$.asObservable();
  }

  disconnect() {
    this.balanceHistory$.complete();
  }

  loadData(body: IBalanceHistoryBody | undefined, page: { size: number, number: number }): void {
    this.isLoading$.next(true);
    this.userService.getUserWalletTransactions(body, page)
      .subscribe((balanceHistory: IBalanceHistoryResponse) => {
        this.balanceHistory$.next(balanceHistory.transactions);
        this.totalCount = balanceHistory.metadata?.amount;
        this.isLoading$.next(false);
      });
  }
}
